function setCookie(name, value) {
  const date = new Date();
  date.setTime(date.getTime() + 24 * 60 * 60 * 1000);
  const expires = date.toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires};`;
}

window.addEventListener('close.bs.alert', function(){
  setCookie("close_alert", true);
});

